import axios from "axios";
import toast from "../../../template/layout/utility/sa-toast";

export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            consensiGruppiItems: [],
            consensiGruppiRecordNumber: 0,
            consensoGruppo: {},
            consensiGruppiPathResource: "/consensisecuritygruppi",
            filter: {
                consenso: null,
                gruppo: null
            }
        };
    },
    methods: {
        gruppiConsensiLoadData() {
            this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + this.consensiGruppiPathResource;
            this.consensiGruppiItems = [];
            axios.get(link, { params: this.filter })
                .then((response) => {
                    this.consensiGruppiItems = response.data.data.list;
                    this.consensiGruppiRecordNumber = response.data.data.recordNumber;
                    this.closeShowModalLoading();
                })
                .catch((error) => {
                    this.closeShowModalLoading();
                    toast.error(error, "Errore");
                });

        },
        salvaAssociazione(associazione, success) {
            let link = process.env.VUE_APP_PATH_API + this.consensiGruppiPathResource;
            axios.post(link, associazione)
                .then((response) => {
                    toast.success("Associazione salvata con successo", "Operazione Avvenuta con successo");
                    success(response);
                    this.closeShowModalLoading();
                })
                .catch((err) => {
                    this.closeShowModalLoading();
                    if (err.response.data) {
                        toast.error(err.response.data.messaggio, "Attenzione");

                    }

                });
        },
        eliminaAssociazione(associazione, success) {
            let link = process.env.VUE_APP_PATH_API + this.consensiGruppiPathResource + "/" + associazione.id;
            axios.delete(link, associazione)
                .then((response) => {
                    toast.success("Associazione Eliminata con successo", "Operazione Avvenuta con successo");

                    success(response);
                    this.closeShowModalLoading();
                })
                .catch((err) => {
                    this.closeShowModalLoading();
                    if (err.response.data) {
                        toast.error(err.response.data.messaggio, "Attenzione");

                    }

                });
        }
    },
};
